import React, { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'

import { ContainerParent, DeviceType, Mode } from '../../models/enums'

import Background from '../Common/Background'
import OldUserRequest from '../AnswerPanel/OldUserRequest'
import UserRequest from '../AnswerPanel/UserRequest'
import Logo from '../Common/Logo'
import OldBotResponse from '../AnswerPanel/OldBotResponse'
import BotResponse from '../AnswerPanel/BotResponse'
import RetorikLogo from '../Common/RetorikLogo'
import SubViews from './SubViews'
import ConversationPanel from '../AnswerPanel/ConversationPanel'
import OldMenuDisplayer from '../Menu/MenuDisplayer'
import MenuDisplayer from '../Menus/MenuDisplayer'
import ExtendIcon from '../Icons/Miscellaneous/ExtendIcon'
import Modal from '../Common/Modal'
import PositionModal from '../Utils/PositionModal'

interface HomeViewProps {
  externalComponents?: Array<{ name: string; component: JSX.Element }>
}

const HomeView = ({ externalComponents }: HomeViewProps): JSX.Element => {
  const dispatch = useDispatch()
  const currentLayout = useSelector((state: RootState) => state.retorikReducer.currentLayout)
  const loaderClosed = useSelector((state: RootState) => state.retorikReducer.loaderClosed)
  const configuration = useSelector((state: RootState) => state.retorikReducer.configuration)
  const showPositionModal = useSelector((state: RootState) => state.retorikReducer.showPositionModal)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const isMobile = useSelector((state: RootState) => state.viewReducer.isMobile)
  const currentDeviceType = useSelector((state: RootState) => state.viewReducer.currentDeviceType)
  const configurations = useSelector((state: RootState) => state.viewReducer.configurations)

  const displayData = useMemo(() => {
    return configurations.views.home
  }, [configurations])

  useEffect(() => {
    dispatch(storeActions.view.setDisplayControls(!configuration.hideControls))
  }, [])

  const extendButtonHandler = () => {
    dispatch(storeActions.retorik.setLayout(ContainerParent.widget))
    dispatch(storeActions.widget.openWidget())
  }

  return (
    <React.Fragment>
      {!!configuration.allowSwitchLayout && currentLayout !== ContainerParent.widget && (currentDeviceType === DeviceType.widgetLandscape || currentDeviceType === DeviceType.widgetBorne) && (
        <button
          onClick={extendButtonHandler}
          aria-label='Minimize'
          className='rf-absolute rf-z-exitwidget rf-flex rf-top-1 rf-p-1 rf-bg-truewhite rf-border rf-border-trueblack rf-rounded-lg rf-right-10'
        >
          <ExtendIcon className='rf-h-4 rf-w-4' color='#000000' extended={true} />
        </button>
      )}
      {/* Background */}
      <Background config={displayData.background} />

      {/* Logo */}
      {configuration?.logo && (!isMobile || (isMobile && mode !== Mode.text)) && <Logo />}

      {/* Activity input / output */}
      {configuration?.answerpanel !== false && loaderClosed && (
        <React.Fragment>
          {!isMobile && (configuration.useOldRemote ? <OldUserRequest /> : <UserRequest />)}
          {mode === Mode.vocal ? configuration.useOldRemote ? <OldBotResponse /> : <BotResponse /> : <ConversationPanel />}
        </React.Fragment>
      )}

      {/* Menus */}
      {configuration.useOldRemote ? <OldMenuDisplayer hideMenu={configuration?.hideMenu} /> : <MenuDisplayer hideMenu={configuration?.hideMenu} />}

      {/* Miscellaneous */}
      {loaderClosed && <SubViews externalComponents={externalComponents} />}

      {/* Retorik Logo on right bottom */}
      {!configuration?.hideRetorikLogo && <RetorikLogo />}

      {/* Modal if localization data are needed but not given */}
      {!(configuration.position?.latitude && configuration.position?.longitude) && (
        <Modal isOpened={showPositionModal} onClose={() => dispatch(storeActions.retorik.setShowPositionModal(false))}>
          <PositionModal />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default HomeView
